/** Cardinal movement with a small neutral zone and direction-change hysteresis. */
export class CardinalStick {
  private axis: 'x' | 'y' | null = null;
  sample(dx: number, dy: number): { x: number; y: number } {
    const distance = Math.hypot(dx, dy);
    if (distance <= 6) { this.reset(); return { x: 0, y: 0 }; }
    const ax=Math.abs(dx), ay=Math.abs(dy);
    if (this.axis === null) this.axis = ax >= ay ? 'x' : 'y';
    else if (this.axis === 'x' && ay > ax * 1.2) this.axis = 'y';
    else if (this.axis === 'y' && ax > ay * 1.2) this.axis = 'x';
    const strength=Math.min(1,(distance-6)/30);
    return this.axis==='x' ? {x:Math.sign(dx)*strength,y:0} : {x:0,y:Math.sign(dy)*strength};
  }
  reset(): void { this.axis=null; }
}
